module.exports = __webpack_public_path__ + "img/Subtract.21ba4e5.png";